import { render } from "./MaterialSwitch.vue?vue&type=template&id=4e1351be"
import script from "./MaterialSwitch.vue?vue&type=script&lang=js"
export * from "./MaterialSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__